var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11636_54564)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55.0006,
    r: 45,
    fill: "url(#paint0_radial_11636_54564)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55.0006,
    r: 45,
    fill: "url(#paint1_linear_11636_54564)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9875 53.9342H62.55C62.875 53.9342 63.1437 53.828 63.3562 53.6155C63.5687 53.403 63.675 53.1342 63.675 52.8092C63.675 52.4842 63.5687 52.2155 63.3562 52.003C63.1437 51.7905 62.875 51.6842 62.55 51.6842H49.9875C49.6625 51.6842 49.3938 51.7905 49.1813 52.003C48.9688 52.2155 48.8625 52.4842 48.8625 52.8092C48.8625 53.1342 48.9688 53.403 49.1813 53.6155C49.3938 53.828 49.6625 53.9342 49.9875 53.9342ZM49.9875 57.3092H56.175C56.5 57.3092 56.7688 57.203 56.9813 56.9905C57.1938 56.778 57.3 56.5092 57.3 56.1842C57.3 55.8592 57.1938 55.5905 56.9813 55.378C56.7688 55.1655 56.5 55.0592 56.175 55.0592H49.9875C49.6625 55.0592 49.3938 55.1655 49.1813 55.378C48.9688 55.5905 48.8625 55.8592 48.8625 56.1842C48.8625 56.5092 48.9688 56.778 49.1813 56.9905C49.3938 57.203 49.6625 57.3092 49.9875 57.3092ZM49.9875 50.5592H62.55C62.875 50.5592 63.1437 50.453 63.3562 50.2405C63.5687 50.028 63.675 49.7592 63.675 49.4342C63.675 49.1092 63.5687 48.8405 63.3562 48.628C63.1437 48.4155 62.875 48.3092 62.55 48.3092H49.9875C49.6625 48.3092 49.3938 48.4155 49.1813 48.628C48.9688 48.8405 48.8625 49.1092 48.8625 49.4342C48.8625 49.7592 48.9688 50.028 49.1813 50.2405C49.3938 50.453 49.6625 50.5592 49.9875 50.5592ZM45.75 65.5592C45.15 65.5592 44.625 65.3342 44.175 64.8842C43.725 64.4342 43.5 63.9092 43.5 63.3092V42.3092C43.5 41.7092 43.725 41.1842 44.175 40.7342C44.625 40.2842 45.15 40.0592 45.75 40.0592H66.75C67.35 40.0592 67.875 40.2842 68.325 40.7342C68.775 41.1842 69 41.7092 69 42.3092V63.3092C69 63.9092 68.775 64.4342 68.325 64.8842C67.875 65.3342 67.35 65.5592 66.75 65.5592H45.75ZM45.75 63.3092H66.75V42.3092H45.75V63.3092ZM41.25 70.0592C40.65 70.0592 40.125 69.8342 39.675 69.3842C39.225 68.9342 39 68.4092 39 67.8092V45.6842C39 45.3592 39.1063 45.0905 39.3188 44.878C39.5313 44.6655 39.8 44.5592 40.125 44.5592C40.45 44.5592 40.7187 44.6655 40.9312 44.878C41.1437 45.0905 41.25 45.3592 41.25 45.6842V67.8092H63.375C63.7 67.8092 63.9688 67.9155 64.1813 68.128C64.3938 68.3405 64.5 68.6092 64.5 68.9342C64.5 69.2592 64.3938 69.528 64.1813 69.7405C63.9688 69.953 63.7 70.0592 63.375 70.0592H41.25ZM45.75 42.3092V63.3092V42.3092Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8312 11.6609C53.8312 10.7439 53.0875 9.99728 52.1713 10.0325C44.0839 10.343 36.2271 12.9175 29.4799 17.486C22.2719 22.3664 16.6539 29.3032 13.3364 37.4191C10.019 45.535 9.15097 54.4655 10.8422 63.0812C12.4254 71.1464 16.1845 78.5967 21.6867 84.6113C22.3073 85.2896 23.3659 85.2876 24.0117 84.6332C24.6455 83.991 24.6428 82.9608 24.0351 82.2938C18.9741 76.7394 15.5156 69.8689 14.0561 62.4334C12.4913 54.4618 13.2944 46.1989 16.3639 38.6898C19.4333 31.1807 24.6313 24.7625 31.3004 20.2469C37.5087 16.0434 44.7322 13.6643 52.1713 13.3556C53.0874 13.3175 53.8312 12.5778 53.8312 11.6609Z",
    fill: "url(#paint2_linear_11636_54564)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11636_54564",
    x: 0,
    y: 0.000610352,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0823529 0 0 0 0 0.196078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11636_54564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11636_54564",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11636_54564",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55.0006) rotate(89.2559) scale(45.0038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762092,
    stopColor: "#0D116B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11636_54564",
    x1: 28.7013,
    y1: 19.9357,
    x2: 52.6623,
    y2: 54.4162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E61D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E62D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11636_54564",
    x1: 53.8312,
    y1: 10.0006,
    x2: 25.7877,
    y2: 86.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/guides.b3da5d3214f151061bb44743cfe32ee6.svg";
export { ForwardRef as ReactComponent };